export const SET_RECOMMENDATIONS = "dashboard/SET_RECOMMENDATIONS"
export const GET_RECOMMENDATIONS = "dashboard/GET_RECOMMENDATIONS"
export const SET_OFFICES = "dashboard/SET_OFFICES"
export const SELECT_OFFICE = "dashboard/SELECT_OFFICE"
export const SET_PLAN_PROVIDERS = "dashboard/SET_PLAN_PROVIDERS"
export const SELECT_PLAN_PROVIDER = "dashboard/SELECT_PLAN_PROVIDER"
export const SET_PLANS = "dashboard/SET_PLANS"
export const SELECT_PLAN = "dashboard/SELECT_PLAN"
export const SELECT_HOLDER = "dashboard/SELECT_HOLDER"
export const SET_PLAN_INFORMATION = "dashboard/SET_PLAN_INFORMATION"



// WEBPACK FOOTER //
// ./assets/dashboard/actionTypes.js